import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { Messages } from '../../codegen/Localize';
import { ISubscriptionInfo, SubscriptionTargetTypes } from '../models/ISubscriptionInfo';

export module SubscriptionGrid {

  export function getTargetLinkMetadata(subscription: ISubscriptionInfo) {
    const siteUrlsForRow = new SpacesSiteUrls({ siteUrlName: subscription.site.urlName });
    let iconClassName: string;
    let iconTitle: string;
    let url: string;

    if (subscription.targetType === SubscriptionTargetTypes.flow) {
      iconClassName = 'tb-grid-icon-flow';
      iconTitle = Messages.flow();
      url = siteUrlsForRow.flowUrl(subscription.targetId);
    } else if (subscription.targetType === SubscriptionTargetTypes.view) {
      if (subscription.attachImage && subscription.attachPdf) {
        iconClassName = 'tb-grid-icon-view-attached-all';
        iconTitle = Messages.subscriptionFormatViewImagePdf();
      } else if (subscription.attachPdf) {
        iconClassName = 'tb-grid-icon-view-attached-pdf';
        iconTitle = Messages.subscriptionFormatViewPdf();
      } else {
        iconClassName = 'tb-grid-icon-view';
        iconTitle = Messages.subscriptionFormatViewImage();
      }

      url = siteUrlsForRow.viewUrl(subscription.targetPath);
    } else {
      if (subscription.attachImage && subscription.attachPdf) {
        iconClassName = 'tb-grid-icon-workbook-attached-all';
        iconTitle = Messages.subscriptionFormatWorkbookImagePdf();
      } else if (subscription.attachPdf) {
        iconClassName = 'tb-grid-icon-workbook-attached-pdf';
        iconTitle = Messages.subscriptionFormatWorkbookPdf();
      } else {
        iconClassName = 'tb-grid-icon-workbook';
        iconTitle = Messages.subscriptionFormatWorkbookImage();
      }

      url = siteUrlsForRow.workbookUrl(subscription.targetId);
    }

    return {
      text: subscription.targetName,
      url: url,
      iconClassName: iconClassName,
      iconTitle: iconTitle
    };
  }
}
